export const AUTH_SCOPES = [
  "openid",
  "profile",
  "email",
  "platform:entity/*::appstore_*",
  "platform:entity/*::webhooks_*",
];
